import { render, staticRenderFns } from "./NormalSearchNav118.vue?vue&type=template&id=1a97352c&scoped=true"
import script from "./NormalSearchNav118.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav118.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97352c",
  null
  
)

export default component.exports